<template>
    <v-dialog v-model="dialog" @keydown.esc="closeModal()" persistent max-width="600px">
        <template v-slot:activator="{ on }"> 
            <v-textarea v-model="end" label="Endereço para Entrega dos Presentes (Clique para Abrir o Assistente)" v-on="on"/>
        </template>
            <v-card>
                <v-card-title>
                    <span class="headline">Informe o Endereço de Entrega</span>
                </v-card-title>                
                <v-card-text>
                    <v-form ref="form">
                        <v-row dense align="center" align-content="center" justify="center">
                            <v-col cols="12" lg="2" xl="2">
                                <v-text-field :rules="[rules.required]" v-mask="'#####-###'" id="cep" v-model="cep" label="CEP *" required v-on:keyup="buscar"></v-text-field>                                                    
                            </v-col>    
                            <v-col cols="12" lg="8" xl="8">
                                <v-text-field :rules="[rules.required]" v-model="endereco.logradouro" label="Endereco *" required readonly prepend-inner-icon="mdi-map-marker"></v-text-field>                                                    
                            </v-col>      
                            <v-col cols="4" lg="2" xl="2">
                                <v-text-field :rules="[rules.required]" id="numero" v-model="endereco.numero" label="Núm. *" required></v-text-field>                                                    
                            </v-col> 
                            <v-col cols="8" lg="3" xl="3">
                                <v-text-field :rules="[rules.required]" v-model="endereco.bairro" label="Bairro *" required></v-text-field>                                                    
                            </v-col>                
                            <v-col cols="12" lg="3" xl="3">
                                <v-text-field v-model="endereco.complemento" label="Complemento" ></v-text-field>                                                    
                            </v-col>
                            <v-col cols="9" lg="5" xl="5">
                                <v-text-field :rules="[rules.required]" v-model="endereco.localidade" label="Cidade *" required readonly></v-text-field>                                                    
                            </v-col>  
                            <v-col cols="3" lg="1" xl="1">
                                <v-text-field :rules="[rules.required]" v-model="endereco.uf" label="UF *" required readonly></v-text-field>                                                    
                            </v-col>    
                            <v-col cols="12">
                                <v-text-field :rules="[rules.required]" v-model="destinatario" label="Nome do Destinatário(a) *" required ></v-text-field>                                                    
                            </v-col>                     
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>            
                    <v-btn color="blue darken-1" text @click="sendAddress()">Confirmar</v-btn>
                </v-card-actions>                 
            </v-card>
    </v-dialog>
</template>
<script>
import $ from 'jquery'
import {mask} from 'vue-the-mask'

export default {
    // components: {TheMask},
    props:['endereco'],
    directives: {mask},
    data: () => ({
        rules: {
            required: value => !!value || 'Campo Obrigatório.', 
        },
        endereco: '',
        cep: '',
        end: '',
        dialog: false,
        destinatario: ''
    }),
    created(){
        this.end = this.endereco
    },
    methods:{
        sendAddress(){
            if (this.$refs.form.validate()) {
                this.end = ''
                this.end = this.destinatario + '\r\n'
                this.end = this.end + this.endereco.logradouro + ', N°. '+ this.endereco.numero 
                if ((typeof this.endereco.complemento != "undefined") && (this.endereco.complemento != ""))
                    this.end = this.end + ', ' + this.endereco.complemento
                this.end = this.end + '\r\n' + this.endereco.bairro
                this.end = this.end + '\r\n' + this.endereco.localidade +'/'+this.endereco.uf
                this.end = this.end + '\r\n' + 'CEP: '+ this.endereco.cep
                this.$emit("closeAddress", this.end)
                this.dialog = false
            }            
        },
        closeModal(){
          this.dialog = false
        },
        buscar(){
            var self = this;
            
            self.naoLocalizado = false;
            
            if(/^[0-9]{5}-[0-9]{3}$/.test(this.cep)){
                $.getJSON("https://viacep.com.br/ws/" + this.cep + "/json/", function(endereco){
                if(endereco.erro){
                    self.endereco = {};
                    $("#logradouro").focus();
                    self.naoLocalizado = true;
                    return;
                }
                self.endereco = endereco;
                // console.log(endereco);
                $("#numero").focus();
                });
            }
        },         
    }   
}
</script>